module.exports = __webpack_public_path__ + "media/images/common/icon/icon-star-3dcd050ffb7990aa5139c9b65ae691fc.svg";